import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import OpenApiClientButton_vue_vue_type_script_setup_true_lang_default from "./OpenApiClientButton.vue.script.js";
/* empty css                                  */
//#region src/v2/blocks/operation-block/components/OpenApiClientButton.vue
var OpenApiClientButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(OpenApiClientButton_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-cd067f84"]]);
//#endregion
export { OpenApiClientButton_default as default };

//# sourceMappingURL=OpenApiClientButton.vue.js.map